import { render, staticRenderFns } from "./floatService.vue?vue&type=template&id=53cbddd4&scoped=true&"
import script from "./floatService.vue?vue&type=script&lang=js&"
export * from "./floatService.vue?vue&type=script&lang=js&"
import style0 from "./floatService.vue?vue&type=style&index=0&id=53cbddd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cbddd4",
  null
  
)

export default component.exports